/**
 * Notifications follow the language on screen.
 *
 * `users.locale` decides email, push and WhatsApp. It used to be written once,
 * from a guess at registration, and afterwards only by an explicit choice - so
 * a member reading Spanish could go on receiving Arabic, and a dialog asked
 * them about it (INV-I18N-9, first version). Big apps do not ask: the site
 * speaks the language the member picked or the browser's, notifications
 * quietly follow it, and the language picker is the manual override. So after
 * sign-in the language on screen is sent whenever it differs from the stored
 * one. Last device used wins, as on those apps. Mirrors
 * `mobile_flutter/lib/core/utils/notification_language.dart`.
 *
 * @returns {?string} the language to send, or null when there is nothing to do.
 */
export function notificationLanguageToSync({ stored, onScreen, supported }) {
  if (!onScreen || !(supported || []).includes(onScreen)) return null;
  if (stored === onScreen) return null;
  return onScreen;
}
